import {
  Box,
  Button,
  Card,
  DialogActions,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  approvePendingAccount,
  getAccountWithActions,
  getPendingAccountList,
} from "../../services/services";
import ListHead from "../table/ListHead";
import Scrollbar from "../table/Scrollbar";
import RejectPendingAccount from "./Dialogs/RejectPendingAccount";
import { applySortFilter } from "../../utils/tableFunctions";
import { StyledTableRow } from "../TableRow";
import { useLoadingSpinnerContext } from "../../context/loadingSpinnerContext";
import { CustomTableCell } from "../TableCell";
import CommonDialog from "../CustomDialog";
import AccountDetails from "../../pages/details/admin/AccountDetails";
import CircularLoader from "../circularLoader";
import { styles } from "../../utils/styles";
import Pagination from "../Pagination";
import { pageNumber, rowsPerPage } from "../../utils/constants";

const TABLE_HEAD = [
  { id: "email", label: "Email" },
  { id: "group", label: "Role" },
  { id: "action", label: "Action" },
  { id: "approve" },
];

const PendingAccount = ({ userRole }) => {
  const { setGlobalLoading } = useLoadingSpinnerContext();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [accountList, setAccountList] = useState({ results: [], count: 0 });
  const [loaded, setLoaded] = useState(false);
  const [pendingDetails, setPendingDetails] = useState(null);

  const [pagination, setPagination] = useState({
    page: pageNumber,
    page_size: rowsPerPage,
  });

  // dialogs
  const [openRejectDialog, setOpenRejectDialog] = useState(false);
  const [selectedId, setSelectedId] = useState();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const filteredList = applySortFilter(
    accountList.results || [],
    order,
    orderBy
  );

  const isItemNotFound = filteredList.length === 0;

  const renderData = data => {
    const results = data.results || [];
    const newData = results.map(item => ({
      ...item,
      group: item.group?.name
    }))
    setAccountList({
      ...data,
      results: newData
    });
  }

  const queryPage = (queryParams) => {
    setLoaded(false);
    getPendingAccountList({
      setResponse: renderData,
      setLoaded: setLoaded,
      queryParams: queryParams
    });
    setPagination(queryParams);
  };

  const handleChangePage = (event, newPage) => {
    queryPage({
      page: newPage + 1,
      page_size: pagination.page_size,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    queryPage({
      page: 1,
      page_size: event.target.value,
    });
  };

  useEffect(() => {
    queryPage(pagination);
  }, []);

  const handleCloseDialog = (shouldResetDetails) => {
    setOpenRejectDialog(false);
    if (shouldResetDetails === true) setPendingDetails(null);
  };
  return (
    <Box>
      {loaded ?
        <Card>
          <Scrollbar>
            <TableContainer>
              <Table>
                <ListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  onRequestSort={handleRequestSort}
                  checkbox={false}
                />

                <TableBody>
                  {filteredList.map((row) => {
                        const { id, email, group, action } = row;

                        return (
                          <StyledTableRow
                            hover
                            key={id}
                          >
                            <CustomTableCell
                              field={email}
                            />
                            <CustomTableCell
                              field={group}
                            />
                            <CustomTableCell
                              field={action}
                            />
                            <TableCell>
                              <Button
                                variant="text"
                                color="secondary"
                                onClick={() => {
                                  setGlobalLoading(true);
                                  getAccountWithActions(id, setPendingDetails, () => setGlobalLoading(false));
                                }}
                              >
                                View Detail
                              </Button>
                            </TableCell>
                          </StyledTableRow>
                        );
                      })}
                </TableBody>
                {isItemNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper>
                          <Typography
                            gutterBottom
                            align="center"
                            variant="subtitle1"
                          >
                            There is no pending account at the moment.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          {!isItemNotFound && (
            <Pagination
              count={accountList.count}
              pagination={pagination}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Card>
        :
        <CircularLoader />
      }
      {selectedId && (
        <RejectPendingAccount
          open={openRejectDialog}
          onClose={handleCloseDialog}
          selectedId={selectedId}
          setAccountList={renderData}
          setLoaded={setLoaded}
          pagination={pagination}
        />
      )}

      {pendingDetails && (
        <CommonDialog
          title="Account Details"
          onClose={() => setPendingDetails(null)}
          renderActions={() =>
            userRole.includes("Approve/Reject") && (
              <DialogActions>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setOpenRejectDialog(true);
                    setSelectedId(pendingDetails.id);
                  }}
                >
                  Reject
                </Button>
                <Button
                  variant="contained"
                  onClick={async () => {
                    setGlobalLoading(true);
                    await approvePendingAccount(
                      pendingDetails.id,
                      renderData,
                      setLoaded,
                      pagination
                    )
                    setPendingDetails(null);
                    setGlobalLoading(false);
                  }}
                  sx={{ ...styles.customButton }}
                >
                  Approve
                </Button>
              </DialogActions>
            )
          }
        >
          <AccountDetails detailsData={pendingDetails} />
        </CommonDialog>
      )}
    </Box>
  );
};

export default PendingAccount;
